import { Activity, BodyProps } from "@ofqual/portal-activity-feed";
import { ContactTheRegulator } from "../../../domain/ContactTheRegulator";

export enum DialogType {
  ActivityAction,
  SendMessage,
}

export interface EntityDialog {
  dialogType: DialogType;
  focussedActivity?: Activity;
}

export type ActivityDocument = {
  blobId: string;
  fileName: string;
  contentType: string;
}

export type AttachmentActivityBody = {
  message: string;
  documents: ActivityDocument[];
};

export type AttachmentBodyProps = {
  bodyProps: BodyProps<AttachmentActivityBody>;
};
